import { IFilterParams } from '../interfaces/IFilterParams';

//This class defines search parameters and instantiates properties.
export class FilterParams implements IFilterParams {
    LastName: string = "";
    Country: string = "";
    State: string = "";
    City: string = "";
    ZipCode: string = "";
    Language: string = "";
    Specialty: string = "";
    Interest: string = "";
    AddedType: string = "";
    AddedValue: string = "";
    IsReset: boolean = true;
}